import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
import { AvmCalculatorFormComponent } from './avm-calculator-form/avm-calculator-form.component';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key: "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key: "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key: "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
  {
    key: "CITY-CODE",
    value: '{{CITY-CODE}}',
    required: true
  },
];
// avm-calculator.component.ts - Updated QueryData

const QueryData: any = [
  {
    param: "property_uid",
    value: '{{property_uid}}',
    required: true
  },
  {
    param: "land_area (in sqm)",
    value: '{{land_area}}',
    required: true
  },
  {
    param: "built_area (in sqm)",
    value: '{{built_area}}',
    required: true
  },
  {
    param: "floor",
    value: '{{floor}}',
    required: false
  },
  {
    param: "basement",
    value: '{{basement}}',
    required: false
  },
  {
    param: "building_age",
    value: '{{building_age}}',
    required: false
  },
  {
    param: "finish_quality",
    value: '{{finish_quality}}',
    required: false
  },
  {
    param: "basement_uses",
    value: '{{basement_uses}}',
    required: false
  },
  {
    param: "shaded_parking",
    value: '{{shaded_parking}}',
    required: false
  }
];
@Component({
  selector: 'app-avm-calculator',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent, AvmCalculatorFormComponent],
  templateUrl: './avm-calculator.component.html'
})
export class AvmCalculatorComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router) {

  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.avmCalculator);
          if (!matched?.methods?.includes(HTTPMethod.GET)) {
            this.router.navigate(['/'])
          }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {

  }

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.avmCalculator}`;

api_response = `{
  "status": 200,
  "message": "string",
  "data": {
    "land_price": {
      "sale_price_min": number,
      "sale_price_max": number
    },
    "properties_price": {
      "sale_price_min": number,
      "sale_price_max":number
    }
  }
}`;

}
